/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';




am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const PieAndBarSummaryChart = (props) => {

    const { sBA, data, IsExport } = props

    useEffect(() => {
        if (data != null) {
            onRenderGraphPie(data.lstdataPie)
            GraphStackClusteredBar(data)
        }
    }, [data,IsExport])

    const onRenderGraphPie = (data) => {


        let chart = am4core.create("typevoc-pie", am4charts.PieChart);

        // Add data
        chart.data = data;

        // Add and configure Series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "name";

        var colorSet = new am4core.ColorSet();
        colorSet.list = ["#85c5e3", "#9985e3", "#e385d8", "#dc6967", "#dcd267", "#7ddc67"].map(color => {
          return am4core.color(color);
        });
        pieSeries.colors = colorSet;
        // pieSeries.ticks.template.disabled = true;
        // pieSeries.labels.template.disabled = true;
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;
        pieSeries.legendSettings.labelText = "{category}";
        pieSeries.labels.template.fontSize = 12;
        pieSeries.labels.template.paddingTop = 0;
        pieSeries.labels.template.paddingBottom = 0;
        pieSeries.labels.template.text = "{value}, {sPercent}%";
        pieSeries.labels.template.maxWidth = 150;
        pieSeries.labels.template.wrap = true;
        pieSeries.alignLabels = false;
        pieSeries.slices.template.tooltipText = "{category}: {value}, {sPercent}%";

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

        chart.hiddenState.properties.radius = am4core.percent(0);

        chart.legend = new am4charts.Legend();
        chart.legend.useDefaultMarker = true;
        chart.legend.labels.template.text = "{name}[/]";
        chart.legend.valueLabels.template.disabled = true;

        chart.legend.verticalCenter = "middle";

        var marker = chart.legend.markers.template.children.getIndex(0) as any;
        // marker.width = 8;
        // marker.height = 8;
        // marker.verticalCenter = "midd";
        marker.cornerRadius(12, 12, 12, 12);
        marker.strokeWidth = 2;
        marker.strokeOpacity = 1;
        marker.stroke = am4core.color("#ccc");
        if(IsExport == true)
        {
            setTimeout(() => {
                chart.exporting.getImage("png").then((data) => {
                    let obj = {
                        id: 2,
                        nOrder: 1,
                        sDesc: "pieAVG",
                        sName : "Type VOC",
                        idDiv : 2,
                        imgBase64: data
                    }
                    props.exportImg && props.exportImg(obj);
                });
            }, 2000);
        }

      
    }

    const GraphStackClusteredBar = (lstdata) => {
        let chart = am4core.create("chart-year", am4charts.XYChart);
        chart.colors.step = 2;

        chart.legend = new am4charts.Legend()
        chart.legend.position = 'bottom'
        // chart.legend.paddingBottom = 20
        chart.legend.labels.template.maxWidth = 95

        let xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
        xAxis.dataFields.category = 'sMonth'
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 20;
        xAxis.renderer.cellStartLocation = 0.1;
        xAxis.renderer.cellEndLocation = 0.9;
        // xAxis.renderer.labels.template.rotation = -45;
        xAxis.renderer.labels.template.horizontalCenter = "middle";
        xAxis.renderer.labels.template.verticalCenter = "middle";

        let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;

        function createSeries(value, name) {
            let series = chart.series.push(new am4charts.ColumnSeries())
            series.dataFields.valueY = value
            series.dataFields.categoryX = 'sMonth'
            series.name = name
            series.columns.template.tooltipText = name + ": [bold]{valueY}[/]";


            series.events.on("hidden", arrangeColumns);
            series.events.on("shown", arrangeColumns);

            let bullet = series.bullets.push(new am4charts.LabelBullet())
            bullet.interactionsEnabled = false
            bullet.dy = 30;
            bullet.label.text = '{valueY}'
            bullet.label.fill = am4core.color('#ffffff')

            return series;
        }
        //ปีจะเป็นปีที่เลือก
        chart.data = lstdata.lstdataXY;
        let lstYear = lstdata.lstYear || [];
        if(lstYear != null && lstYear.length > 0)
        {
            lstYear.forEach(element => {
                createSeries(element,element);
            });
        }

        function arrangeColumns() {

            let series = chart.series.getIndex(0);

            let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
            if (series.dataItems.length > 1) {
                let x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                let x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
                let delta = ((x1 - x0) / chart.series.length) * w;
                if (am4core.isNumber(delta)) {
                    let middle = chart.series.length / 2;

                    let newIndex = 0;
                    chart.series.each(function (series) {
                        if (!series.isHidden && !series.isHiding) {
                            series.dummyData = newIndex;
                            newIndex++;
                        }
                        else {
                            series.dummyData = chart.series.indexOf(series);
                        }
                    })
                    let visibleCount = newIndex;
                    let newMiddle = visibleCount / 2;

                    chart.series.each(function (series) {
                        let trueIndex = chart.series.indexOf(series);
                        let newIndex = series.dummyData;

                        let dx = (newIndex - trueIndex + middle - newMiddle) * delta
                        series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                        series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    })
                }
            }
        }

        if(IsExport == true)
        {
            setTimeout(() => {
                chart.exporting.getImage("png").then((data) => {
                    let obj = {
                        id: 2,
                        nOrder: 2,
                        sDesc: "",
                        sName : "year",
                        idDiv : 2,
                        imgBase64: data
                    }
                    props.exportImg && props.exportImg(obj);
                });
            }, 2000);
        }
       
    }

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Typography style={{fontWeight:500}}>กลุ่มตลาด: {sBA}</Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                    <div id="typevoc-pie" style={{ width: "80%", height: "400px",margin:'auto' }}></div>
                </Grid>
                <Grid item xs={12} md={7}>
                    <div id="chart-year" style={{ width: "100%", height: "400px" }}></div>
                </Grid>
            </Grid>
        </>
    )
}

export default PieAndBarSummaryChart